import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { Box, Button } from "@mui/material";

const CustomButton = styled(Button)(() => ({
  fontFamily: "Urbanist, Verdana, Arial, sans-serif",
  fontSize: "12px",
  letterSpacing: "0.10em",
  borderRadius: "8px",
  fontWeight: "600",
  textTransform: "none",
  color: "white",
  backgroundColor: "#3299FF",
  "&:hover": {
    backgroundColor: "#2878CC",
  },
}));

const CustomOutlinedButton = styled(Button)(() => ({
  fontFamily: "Urbanist, Verdana, Arial, sans-serif",
  fontSize: "12px",
  letterSpacing: "0.10em",
  borderRadius: "8px",
  fontWeight: "600",
  textTransform: "none",
  borderColor: "#3299FF",
  color: "#3299FF",
  "&:hover": {
    borderColor: "#3299FF",
    backgroundColor: "#E0F2FF",
  },
}));

function EditByRowIndex({ handleEdit, onClose, maxRowIndex }) {
  const toRowDefaultValue = maxRowIndex >= 90 ? 90 : maxRowIndex;
  const [fromRow, setFromRow] = useState(1);
  const [toRow, setToRow] = useState(toRowDefaultValue);
  const [disableEdit, setDisableEdit] = useState(false);
  const [validationMessage, setValidationMessage] = useState("");

  const resetFlags = () => {
    setDisableEdit(false);
    setValidationMessage("");
  };

  const validate = (fromRowIndex, toRowIndex) => {
    const fromIndex = Number(fromRowIndex);
    const toIndex = Number(toRowIndex);

    if (fromIndex <= 0 || fromIndex > toIndex) {
      setDisableEdit(true);
      setValidationMessage(
        "From row index cannot be greater than To row index."
      );
    } else if (toIndex <= 0 || toIndex > Number(maxRowIndex)) {
      setDisableEdit(true);
      setValidationMessage(
        `To row index cannot be greater than max row count: ${maxRowIndex}`
      );
    } else {
      resetFlags();
    }
  };

  useEffect(() => {
    validate(fromRow, toRow);
  }, [fromRow, toRow]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          Edit from Row #&nbsp;
          <TextField
            id="fromIndex"
            type="number"
            onChange={(event) => setFromRow(event.target.value)}
            defaultValue={1}
            sx={{ width: "75px" }}
          />
          &nbsp; To &nbsp;
          <TextField
            id="toIndex"
            type="number"
            onChange={(event) => setToRow(event.target.value)}
            defaultValue={toRowDefaultValue}
            sx={{ width: "75px" }}
          />
        </Box>
      </Grid>
      {disableEdit ? (
        <Grid
          item
          xs={12}
          sx={{
            color: "red",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          {validationMessage}
        </Grid>
      ) : (
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 2,
            }}
          >
            <CustomButton
              variant="contained"
              disabled={disableEdit}
              onClick={() => handleEdit(Number(fromRow), Number(toRow))}
            >
              Edit
            </CustomButton>
            <CustomOutlinedButton variant="outlined" onClick={onClose}>
              Cancel
            </CustomOutlinedButton>
          </Box>
        </Grid>
      )}
    </Grid>
  );
}

EditByRowIndex.propTypes = {
  handleEdit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  maxRowIndex: PropTypes.number.isRequired,
};

export default EditByRowIndex;
